import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { AuthScreen, type AuthMessage, type AuthPage } from '@/screens/auth/AuthScreen';

import '@/styles/auth.css';

const mount = document.querySelector<HTMLElement>('[data-auth-react]');

const parseJson = <T,>(raw: string | undefined, fallback: T): T => {
  try {
    return raw ? (JSON.parse(raw) as T) : fallback;
  } catch {
    return fallback;
  }
};

if (mount) {
  const pages: AuthPage[] = [
    'sign-in',
    'sign-out',
    'forgot',
    'reset',
    'password-change',
    'sso-error',
    'sso-sign-out',
  ];
  const requested = mount.dataset.page || 'sign-in';
  const page = (pages.includes(requested as AuthPage) ? requested : 'sign-in') as AuthPage;

  createRoot(mount).render(
    <StrictMode>
      <AuthScreen
        page={page}
        csrfToken={mount.dataset.csrf || ''}
        action={mount.dataset.action || window.location.pathname + window.location.search}
        logoUrl={mount.dataset.logo || ''}
        next={mount.dataset.next || ''}
        messages={parseJson<AuthMessage[]>(mount.dataset.messages, [])}
        errors={parseJson<string[]>(mount.dataset.errors, [])}
        username={mount.dataset.username || ''}
        resetLinkValid={mount.dataset.resetValid !== '0'}
        /* ?? keeps an explicitly empty data-sign-in-url (no password sign-in). */
        signInUrl={mount.dataset.signInUrl ?? '/auth/sign-in/'}
        forgotPasswordUrl={mount.dataset.forgotUrl || '/account/forgot-password/'}
        ssoLoginUrl={mount.dataset.ssoLoginUrl || ''}
        ssoLogoutUrl={mount.dataset.ssoLogoutUrl || ''}
      />
    </StrictMode>
  );
}
